import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { ReadContractorPlannedHours } from "@/types/contractorPlannedHours";

export const ContractorPlannedHoursService =
  new APIService<ReadContractorPlannedHours>(API.ContractorsPlannedHours);
